import firebase from 'firebase'
import 'firebase/firestore'

firebase.initializeApp({
    apiKey: "AIzaSyDD_1pgFn4z68htAA4ddQAxDa0DtAepoTA",
    authDomain: "code--colab.firebaseapp.com",
    projectId: "code--colab",
    storageBucket: "code--colab.appspot.com",
    messagingSenderId: "148033893953",
    appId: "1:148033893953:web:0afc9fab7ba671d2d8b8c0",
    measurementId: "G-WBV1E8643Q"
});


export default firebase;